import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import PostCard from "../components/PostCard";
import { useAuth } from "../context/AuthContext";

export default function PublicPostPage() {
  const { postId } = useParams();
  const { user } = useAuth();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/posts/${postId}`)
      .then(({ data }) => setPost(data))
      .catch(() => setNotFound(true));
  }, [postId]);

  if (notFound) {
    return (
      <div className="max-w-2xl mx-auto p-8 text-center" data-testid="public-post-not-found">
        <h1 className="font-display text-3xl uppercase tracking-tight text-white">
          Highlight not found
        </h1>
        <p className="text-sm text-[#a3a3a3] mt-2">This post may have been removed.</p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-2 bg-white text-black font-semibold rounded-sm hover:bg-gray-200 transition-colors"
        >
          Go to EGNCY
        </Link>
      </div>
    );
  }

  if (!post) {
    return <div className="max-w-2xl mx-auto p-8 text-[#737373]">Loading…</div>;
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-8 space-y-4" data-testid="public-post-page">
      <PostCard post={post} />
      {!user && (
        <div
          data-testid="public-post-cta"
          className="bg-[#121212] border border-[#262626] rounded-sm p-6 text-center"
        >
          <h2 className="font-display text-2xl uppercase tracking-tight text-white">
            Where footballers get seen.
          </h2>
          <p className="text-sm text-[#a3a3a3] mt-2 max-w-sm mx-auto">
            Join EGNCY to follow {post.author?.name || "this player"}, post your own highlights
            and get in front of scouts.
          </p>
          <div className="flex items-center justify-center gap-2 mt-4">
            <Link
              to="/register"
              data-testid="public-post-join"
              className="px-6 py-2 bg-white text-black font-semibold rounded-sm hover:bg-gray-200 transition-colors text-sm"
            >
              Join EGNCY
            </Link>
            <Link
              to="/login"
              className="px-6 py-2 border border-[#404040] text-white hover:bg-[#1a1a1a] rounded-sm transition-colors text-sm"
            >
              Log in
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
